<nav ngbNav #nav="ngbNav" class="nav-tabs" [destroyOnHide]="false" style="width: 100%; margin: 10px;"
  (navChange)="onTabChange($event)">
  @for (riskSector of riskSektors; track riskSector) {
    <ng-container title="{{riskSector.header}}" id="{{riskSector.header}}"
      [ngbNavItem]="riskSector.header">
      <a ngbNavLink>{{ riskSector.header }}</a>
      <ng-template ngbNavContent>
        <h6 style="margin: 5px;">{{ riskSector.title }}</h6>
        <label for="name">{{ 'RISK-MANAGEMENT.PONDERATION' | translate }}</label>
        <input type="text" class="form-control" id="{{riskSector.header}}_ponderation"
          [(ngModel)]="indicator[riskSector.header]['ponderation']" name="name" #name="ngModel" required>
          <span style="color: var(--success);">{{ 'RISK-MANAGEMENT.DISCREPANCY_RANGE_1' | translate }}: 0% - {{ val[0] }}
          %</span><br/>
          <span style="color: var(--warning);">{{ 'RISK-MANAGEMENT.DISCREPANCY_RANGE_2' | translate }}: {{ val[0] + 1 }}
          % - {{ val[1] - 1 }}%</span><br/>
          <span style="color: var(--danger);">{{ 'RISK-MANAGEMENT.DISCREPANCY_RANGE_3' | translate }}: {{ val[1] }}
          % - 100%</span><br/>
          <mv-slider style="width:100%" [value]="val" [min]="1" [max]="99" [step]="1" [enabled]="true" [range]="true"
          (change)="change($event)"></mv-slider>
        </ng-template>
      </ng-container>
    }
  </nav>
  <div [ngbNavOutlet]="nav" class="mt-0"></div>
